import * as types from './constants';

export const initialState = {
  histogram: []
};

const actions = {

  // Performance Summary Chart
  [types.SET_PERFORMANCE_SUMMARY_CHART]: (state, { payload }) => {
    const data = {
      histogram: payload
    };

    return { ...data };
  },

  [types.CLEAR_PERFORMANCE_SUMMARY_CHART]: () => {
    return { ...initialState };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

